import { logNotFoundTrackingProperties } from "@b2bportal/core-tracking";
import { FlightShopStep } from "@b2bportal/core-types";
import { getHopperFareRatingName } from "@hopper-b2b/types";
import { createSelector } from "@reduxjs/toolkit";
import {
  flightShopProgressSelector,
  getSelectedTripDetailsAndFareDetails,
} from "../../store";

export type FlightSelectedFareTrackingProperties = {
  fare_class: string;
  slice_direction: "outbound" | "return";
};

export const getFlightSelectedFareTrackingProperties = createSelector(
  getSelectedTripDetailsAndFareDetails,
  flightShopProgressSelector,
  (
    selectedTripDetailsAndFareDetails,
    shopStep = FlightShopStep.departure
  ): FlightSelectedFareTrackingProperties => {
    if (
      selectedTripDetailsAndFareDetails == null ||
      selectedTripDetailsAndFareDetails.fareDetails == null ||
      selectedTripDetailsAndFareDetails.fareDetails.slices == null
    ) {
      logNotFoundTrackingProperties(
        "getFlightSelectedFareTrackingProperties",
        "flights"
      );

      return {
        fare_class: "",
        slice_direction:
          shopStep === FlightShopStep.departure ? "outbound" : "return",
      };
    }

    const fareClass =
      getHopperFareRatingName(
        selectedTripDetailsAndFareDetails.fareDetails.slices[0]?.fareShelf
          ?.rating
      ) ?? "";

    return {
      fare_class: fareClass,
      slice_direction:
        shopStep === FlightShopStep.departure ? "outbound" : "return",
    };
  }
);
